import { IColumnProps } from "devextreme-react/data-grid";

import { auditFieldColumns } from "../../../model/metaData";

export const dummyRestfulApiResourceRow = {
  name: "string",
  needAuthentication: true,
  authenticatorUrl: "string",
  clientId: "string",
  clientSecret: "string",
  grantType: "string",
  userId: "string",
  userSecret: "string",
  baseUrl: "string",
  active: true,
  createdBy: "string",
  lastUpdatedBy: "string",
  createdTime: "2025-12-08T14:45:13.378Z",
  lastUpdatedTime: "2025-12-08T14:45:13.378Z"
};

export const dummyRestfulApiScopeRow = {
  restfulApiScopeId: 1,
  scope: "string",
  serviceUrl: "string",
  timeoutSeconds: 0,
};

export const dummyTessituraSettingRow = {
  interfaceType: "Transactions",
  restfulApiResourceName: "TessituraApi",
  restfulApiScopeName: "CustomData",
  procedureId: 91,
  procedureName: "LIP_TRANSACTION_BY_POSTING",
  parameterName: "@posting_date",
  active: true,
  createdBy: "BatchUser",
  lastUpdatedBy: "BatchUser",
  createdTime: "2025-11-25T18:49:04.059254-06:00",
  lastUpdatedTime: "2025-11-25T18:49:04.059254-06:00"
};

export const dummyAccountRow = {
  accountName: "string",
  accountCode: "string",
  accountCodeFormula: "string",
  active: true,
  createdBy: "string",
  lastUpdatedBy: "string",
  createdTime: "2025-01-26T02:36:10.097Z",
  lastUpdatedTime: "2025-01-26T02:36:10.097Z",
};

export const dummyMappingDimensionRow = {
  mappingDimensionName: "string",
  description: "string",
  mappingDimensionType: "FixedListValuesType",
  valueFormula: "string",
  defaultValue: "string",
  defaultValueFormula: "string",
  alternativeValueFormula: "string",
  active: true,
  createdBy: "string",
  lastUpdatedBy: "string",
  createdTime: "2025-01-26T02:36:10.097Z",
  lastUpdatedTime: "2025-01-26T02:36:10.097Z",
};

export const dummyMappingDimensionValueRow = {
  value: "string",
  content: "string",
};

export type GetByParentIdRequest = {
  parentId: any;
};

export const restfulApiResourceColumns = Object.freeze(
  new Map<string, IColumnProps>([
    [
      "name",
      {
        dataField: "name",
        caption: "Name",
      },
    ],
    [
      "needAuthentication",
      {
        dataField: "needAuthentication",
        caption: "Need Authentication?",
      },
    ],
    [
      "authenticatorUrl",
      {
        dataField: "authenticatorUrl",
        caption: "Authenticator Url",
      },
    ],
    [
      "userId",
      {
        dataField: "userId",
        caption: "User Id",
      },
    ],
    [
      "userSecret",
      {
        dataField: "userSecret",
        caption: "Password",
        editorOptions: { mode: "password" },
        customizeText: function (e: any) {
          return "******";
        },
      },
    ],
    [
      "baseUrl",
      {
        dataField: "baseUrl",
        caption: "Base Url",
      },
    ],
    [
      "grantType",
      {
        dataField: "grantType",
        caption: "Grant Type",
      },
    ],
    [
      "active",
      {
        dataField: "active",
        caption: "Active?",
      },
    ],
    ...auditFieldColumns,
  ]),
);

export const restfulApiScopeColumns = Object.freeze(
  new Map<string, IColumnProps>([
    [
      "scope",
      {
        dataField: "scope",
        caption: "Scope",
      },
    ],
    [
      "serviceUrl",
      {
        dataField: "serviceUrl",
        caption: "Service Url",
      },
    ],
    ...auditFieldColumns,
  ]),
);

export const tessituraInterfaceSettingColumns = Object.freeze(
  new Map<string, IColumnProps>([
    [
      "interfaceType",
      {
        dataField: "interfaceType",
        caption: "Interface",
      },
    ],
    [
      "restfulApiResourceName",
      {
        dataField: "restfulApiResourceName",
        caption: "API Resource",
      },
    ],
    [
      "restfulApiScopeName",
      {
        dataField: "restfulApiScopeName",
        caption: "Scope",
      },
    ],
    [
      "procedureId",
      {
        dataField: "procedureId",
        caption: "Procedure Id",
      },
    ],
    [
      "procedureName",
      {
        dataField: "procedureName",
        caption: "Procedure Name",
      },
    ],
    [
      "parameterName",
      {
        dataField: "parameterName",
        caption: "Parameter Name",
      },
    ],
    [
      "active",
      {
        dataField: "active",
        caption: "Active?",
      },
    ],
    ...auditFieldColumns,
  ]),
);

export const accountColumns = Object.freeze(
  new Map<string, IColumnProps>([
    [
      "accountName",
      {
        dataField: "accountName",
        caption: "Account Name",
      },
    ],
    [
      "accountCode",
      {
        dataField: "accountCode",
        caption: "Account Code",
      },
    ],
    [
      "accountCodeFormula",
      {
        dataField: "accountCodeFormula",
        caption: "Account Code Formula",
      },
    ],
    [
      "active",
      {
        dataField: "active",
        caption: "Active?",
      },
    ],
    ...auditFieldColumns,
  ]),
);

export const mappingDimensionColumns = Object.freeze(
  new Map<string, IColumnProps>([
    [
      "mappingDimensionName",
      {
        dataField: "mappingDimensionName",
        caption: "Name",
      },
    ],
    [
      "description",
      {
        dataField: "description",
      },
    ],
    [
      "valueFormula",
      {
        dataField: "valueFormula",
        width: 300,
      },
    ],
    [
      "defaultValue",
      {
        dataField: "defaultValue",
      },
    ],
    [
      "defaultValueFormula",
      {
        dataField: "defaultValueFormula",
      },
    ],
    [
      "alternativeValueFormula",
      {
        dataField: "alternativeValueFormula",
      },
    ],
    [
      "mappingDimensionType",
      {
        dataField: "mappingDimensionType",
        caption: "Type",
      },
    ],
    [
      "active",
      {
        dataField: "active",
        caption: "Active?",
      },
    ],
    ...auditFieldColumns,
  ]),
);

export const mappingDimensionValueColumns = Object.freeze(
  new Map<string, IColumnProps>([
    [
      "value",
      {
        dataField: "value",
      },
    ],
    ...auditFieldColumns,
  ]),
);

export const dummyJournalEntryExportSettingRow = {
  exportSettingName: "string",
  description: "string",
  active: true,
  createdBy: "string",
  lastUpdatedBy: "string",
  createdTime: "2025-01-26T02:36:10.097Z",
  lastUpdatedTime: "2025-01-26T02:36:10.097Z",
};

export const dummyJournalEntryExportSettingFieldRow = {
  journalEntryExportSettingFieldId: 1,
  fieldName: "string",
  fieldValueFormula: "string",
  order: 1,
  createdBy: "string",
  lastUpdatedBy: "string",
  createdTime: "2025-01-26T02:36:10.097Z",
  lastUpdatedTime: "2025-01-26T02:36:10.097Z",
};

export const journalEntryExportSettingColumns = Object.freeze(
  new Map<string, IColumnProps>([
    [
      "exportSettingName",
      {
        dataField: "exportSettingName",
        caption: "Name",
      },
    ],
    [
      "description",
      {
        dataField: "description",
        caption: "Description",
      },
    ],
    [
      "active",
      {
        dataField: "active",
        caption: "Active?",
      },
    ],
    ...auditFieldColumns,
  ]),
);

export const journalEntryExportSettingFieldColumns = Object.freeze(
  new Map<string, IColumnProps>([
    [
      "fieldName",
      {
        dataField: "fieldName",
        caption: "Field Name",
      },
    ],
    [
      "fieldValueFormula",
      {
        dataField: "fieldValueFormula",
        caption: "Field Value Formula",
        width: 400,
      },
    ],
    ...auditFieldColumns,
  ]),
);

export const dummyMappingRuleTypeSettingRow = {
  ruleType: "JournalEntryTypeMappingRule",
  description: "string",
  active: true,
  createdBy: "string",
  lastUpdatedBy: "string",
  createdTime: "2025-01-26T02:36:10.097Z",
  lastUpdatedTime: "2025-01-26T02:36:10.097Z",
};

export const dummyMappingRuleTypeSettingDimensionOptionRow = {
  mappingRuleTypeSettingDimensionOptionId: 1,
  mappingDimensionName: "string",
  debitUseAlternativeValueFormula: false,
  createdBy: "string",
  lastUpdatedBy: "string",
  createdTime: "2025-01-26T02:36:10.097Z",
  lastUpdatedTime: "2025-01-26T02:36:10.097Z",
};

export const mappingRuleTypeSettingColumns = Object.freeze(
  new Map<string, IColumnProps>([
    [
      "ruleType",
      {
        dataField: "ruleType",
        caption: "Rule Type",
        lookup: {
          dataSource: [
            { value: "JournalEntryTypeMappingRule", text: "Journal Entry Type Mappings" },
            { value: "AffixMappingRule", text: "Affix Mappings" },
            { value: "AccountingDateMappingRule", text: "Accounting Date Mappings" },
            { value: "ReferenceFieldMappingRule", text: "Reference Field Mappings" },
            { value: "GroupMappingRule", text: "Group Mappings" },
            { value: "JournalEntryExportSettingRule", text: "Journal Entry Export Settings" },
          ],
          valueExpr: "value",
          displayExpr: "text",
        },
      },
    ],
    [
      "description",
      {
        dataField: "description",
        caption: "Description",
      },
    ],
    [
      "active",
      {
        dataField: "active",
        caption: "Active?",
      },
    ],
    ...auditFieldColumns,
  ]),
);

export const mappingRuleTypeSettingDimensionOptionColumns = Object.freeze(
  new Map<string, IColumnProps>([
    [
      "mappingDimensionName",
      {
        dataField: "mappingDimensionName",
        caption: "Mapping Dimension Name",
      },
    ],
    [
      "debitUseAlternativeValueFormula",
      {
        dataField: "debitUseAlternativeValueFormula",
        caption: "Debit Use Alternative Value Formula?",
      },
    ],
    ...auditFieldColumns,
  ]),
);
